import { createDefaultPersonalData, PersonalData } from "@/models/PersonalData"

const TRANSACTION_ID_KEY = "teres-transaction-id"
const PERSONAL_DATA = "teres-personal-data"
const PRIVACY_NOTICE = "teres-privacy-notice"
const STORAGE: Storage = window.sessionStorage

class PersistenceService {
  setTransactionId(transactionId: string|null) {
    if (transactionId) {
      STORAGE.setItem(TRANSACTION_ID_KEY, transactionId)
    } else {
      this.removeTransactionId()
    }
  }
  removeTransactionId() {
    STORAGE.removeItem(TRANSACTION_ID_KEY)
  }
  getTransactionId() {
    return STORAGE.getItem(TRANSACTION_ID_KEY)
  }

  setPersonalData(personalData: PersonalData|null) {
    if (personalData) {
      STORAGE.setItem(PERSONAL_DATA, JSON.stringify(personalData))
    } else {
      STORAGE.removeItem(PERSONAL_DATA)
    }
  }

  getPersonalData() {
    const item = STORAGE.getItem(PERSONAL_DATA)
    if (item) {
      try {
        return JSON.parse(item)
      } catch(e) {
        console.warn('Invalid personal data object, cannot deserialize.', e)
      }
    }
    return createDefaultPersonalData()
  }

  removePersonalData() {
    STORAGE.removeItem(PERSONAL_DATA)
  }

  setPrivacyNotice(val: boolean) {
    STORAGE.setItem(PRIVACY_NOTICE, "" + val)
  }

  getPrivacyNotice(): boolean {
    return STORAGE.getItem(PRIVACY_NOTICE) === "true" || false
  }

}

const persistenceService = new PersistenceService();

export {
  persistenceService
};
